/**
 * Header - functionality
 */

window.TV2 = window.TV2 || {};

// TODO: Move to "core library"
const hideScroll = (hide = true) => {
  const header = document.querySelector('.main-header');

  if (hide) {
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.marginLeft = `-${scrollbarWidth}px`;
    document.body.style.width = `calc(100% + ${scrollbarWidth}px)`;
    header.style.marginLeft = `-${scrollbarWidth}px`;
  } else {
    document.documentElement.style.overflow = null;
    document.body.style.marginLeft = null;
    document.body.style.width = '100%';
    header.style.marginLeft = null;
  }
};

/**
 * Toggle / collapse navigation
 */
window.TV2.toggleNavigation = () => {
  const header = document.querySelector('.main-header');
  const navButton = header.querySelector('.navbar__toggle');
  const navMenu = header.querySelector('.navmenu');

  // Toggle
  navButton.classList.toggle('navbar__toggle--open');
  header.classList.toggle('main-header--open');

  // Set aria-tags on expandable menu
  if (header.classList.contains('main-header--open')) {
    navMenu.setAttribute('aria-expanded', 'true');
    hideScroll();
  } else {
    navMenu.setAttribute('aria-expanded', 'false');
    hideScroll(false);
  }
};
